import { render, staticRenderFns } from "./service2.vue?vue&type=template&id=99eb8f5e&scoped=true&"
import script from "./service2.vue?vue&type=script&lang=js&"
export * from "./service2.vue?vue&type=script&lang=js&"
import style0 from "./service2.vue?vue&type=style&index=0&id=99eb8f5e&prod&scoped=true&lang=css&"
import style1 from "./service2.vue?vue&type=style&index=1&id=99eb8f5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99eb8f5e",
  null
  
)

export default component.exports